import { action } from "typesafe-actions";
import { Widget } from "@models/widget";
import { RequestData } from "@models/axios";

export const enum WidgetsActionTypes {
  FETCH_REQUEST = "@@widgets/FETCH_REQUEST",
  FETCH_SUCCESS = "@@widgets/FETCH_SUCCESS",
  FETCH_ERROR = "@@widgets/FETCH_ERROR",

  DELETE_REQUEST = "@@widgets/DELETE_REQUEST",
  DELETE_SUCCESS = "@@widgets/DELETE_SUCCESS",
  DELETE_ERROR = "@@widgets/DELETE_ERROR",

  CREATE_REQUEST = "@@widgets/CREATE_REQUEST",
  CREATE_SUCCESS = "@@widgets/CREATE_SUCCESS",
  CREATE_ERROR = "@@widgets/CREATE_ERROR",

  UPDATE_REQUEST = "@@widgets/UPDATE_REQUEST",
  UPDATE_SUCCESS = "@@widgets/UPDATE_SUCCESS",
  UPDATE_ERROR = "@@widgets/UPDATE_ERROR",

  FETCH_ITEM_REQUEST = "@@widgets/FETCH_ITEM_REQUEST",
  FETCH_ITEM_SUCCESS = "@@widgets/FETCH_ITEM_SUCCESS",
  FETCH_ITEM_ERROR = "@@widgets/FETCH_ITEM_ERROR",

  UPDATE_ORDER_REQUEST = "@@widgets/UPDATE_ROW_REQUEST",
  UPDATE_ORDER_SUCCESS = "@@widgets/UPDATE_ROW_SUCCESS",
  UPDATE_ORDER_ERROR = "@@widgets/PATCH_ERROR"
}

export const fetchRequest = (data: RequestData) => action(WidgetsActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Widget[]) => action(WidgetsActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(WidgetsActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data: RequestData) => action(WidgetsActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data: any) => action(WidgetsActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(WidgetsActionTypes.DELETE_ERROR, message);

export const createRequest = (data: RequestData) => action(WidgetsActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Widget[]) => action(WidgetsActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(WidgetsActionTypes.CREATE_ERROR, message);

export const updateRequest = (data: RequestData) => action(WidgetsActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Widget[]) => action(WidgetsActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(WidgetsActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data: RequestData) => action(WidgetsActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Widget[]) => action(WidgetsActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(WidgetsActionTypes.FETCH_ITEM_ERROR, message);

export const updateOrderRequest = (data: RequestData) => action(WidgetsActionTypes.UPDATE_ORDER_REQUEST, data);
export const updateOrderSuccess = (data: Widget[]) => action(WidgetsActionTypes.UPDATE_ORDER_SUCCESS, data);
export const updateOrderError = (message: string) => action(WidgetsActionTypes.UPDATE_ORDER_ERROR, message);
